<template>
  <SfModalPortal modal-id="reset-check-list-confirmation-modal" :size="'xs'">
    <template #title>
      {{ I18n.t('check_lists.reset_confirmation_modal.title') }}
    </template>

    <template #body>
      <div>
        {{ I18n.t('check_lists.reset_confirmation_modal.body') }}
      </div>
    </template>

    <template #footer>
      <SfButton variant="info" @click="handleCancel">
        {{ I18n.t('common.cancel') }}
      </SfButton>
      <SfButton variant="danger" @click="handleSuccess">
        {{ I18n.t('check_lists.reset_confirmation_modal.confirm') }}
      </SfButton>
    </template>
  </SfModalPortal>
</template>

<script lang="ts" setup>
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import { SfButton } from '@app/shared/vue/components/sf-button'

const I18n = window.I18n

const handleCancel = () => {
  window.modalCitizen.closeModalPortal()
}

const handleSuccess = () => {
  window.modalCitizen.closeModalPortal()
  window.eventHub.$emit('reset-check-list-confirmed')
}
</script>
